import { Session, Actor, SessionServiceInterface, UserType } from './types/propsType';

export const SessionService: SessionServiceInterface = (function (root, factory) {
  let SessionService: SessionServiceInterface = {} as SessionServiceInterface;
  if (root) {
    // If instance exists use it otherwise create new.
    if (root.SessionService) {
      ({ SessionService } = root);
    } else {
      root.SessionService = SessionService;
      return factory(SessionService);
    }
  }

  return SessionService;
})(
  (typeof window === 'object' && window) || (typeof globalThis === 'object' && globalThis) || this,
  function (SessionService: SessionServiceInterface) {
    let userSession: Session = {};
    const getSession = () => {
      const isAnonymous = () => !userSession?.type || userSession?.type === UserType.ANONYMOUS;
      const isRegistered = () => userSession?.type === UserType.REGISTERED;
      const isABO = () => userSession?.type === UserType.ABO;
      const isMember = () => userSession?.type === UserType.MEMBER;
      const isEmployee = () => userSession?.type === UserType.EMPLOYEE;
      const isActor = () => !!userSession.act;
      return {
        session: userSession,
        isAnonymous,
        isRegistered,
        isABO,
        isMember,
        isEmployee,
        isActor,
      };
    };

    /**
     *
     * @function setSession
     * @description setSession method is only meant for framework internal use, and should not be used other PODs.
     */
    const setSession = (SessionsData: Session) => {
      userSession = Object.assign(userSession, SessionsData);
    };

    // Adding methods to Instance.
    SessionService.getSession = getSession;
    SessionService.setSession = setSession;

    return SessionService;
  },
);
export { UserType };
export type { Session, Actor, SessionServiceInterface };
